import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { GrDocumentVerified } from "react-icons/gr";
import "../../../css/IconStyle.css";

const EvInvIcon = () => {
  return <LiaFileInvoiceDollarSolid size={25} className="sidebar-icon" />;
};

export default EvInvIcon;


export const EvInvApprovalIcon = () => {
  return <GrDocumentVerified size={25} className="sidebar-icon" />;
};